import { LoaderCircle } from "lucide-react";

// A separate call inside a submission (BRK-S488; Nav, 2026-10-28): looking up
// an address, searching class codes, sending the application to a carrier,
// reading a dropped document, and later checks such as a commercial-auto
// license. A spinner and a concise message saying why, where the call was
// made: never the global bar, which is the submission's own reads and saves.
// The spinner stops under reduced motion; the words carry it. Inside a status
// that's already there, `announce={false}` keeps it to one.

export function LoadingNote({
  label,
  announce = true,
  className = "",
}: {
  /** Why it waits, in a few words: "Looking up the address…". */
  label: string;
  announce?: boolean;
  className?: string;
}) {
  return (
    <span
      role={announce ? "status" : undefined}
      className={`inline-flex items-center gap-1.5 ${className}`}
    >
      <LoaderCircle
        aria-hidden="true"
        className="h-4 w-4 shrink-0 motion-safe:animate-spin"
      />
      <span>{label}</span>
    </span>
  );
}
